import React, { useState, useLayoutEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FaDice } from 'react-icons/fa';
import { TOOL_SECTIONS } from '../../../rules/tools';
import { useAuth } from '../../../auth/AuthContext';
import { useMe } from '../../../server/rooms';
import AuthModal from '../../auth/AuthModal';
import UserMenu from '../../auth/UserMenu';
import './Header.css';

const Header = () => {
  const { user, loading, configured, signOut } = useAuth();
  /* 관리자에게만 프로필 메뉴에 관리자 항목을 띄운다.
     get_me는 로그인하면 어차피 한 번 부르는 것이라(시즌 확인도 여기서 한다)
     따로 요청이 늘지 않는다 */
  const { me } = useMe(user?.id);
  const [showAuth, setShowAuth] = useState(false);
  const box = useRef(null);

  /* 헤더가 두 줄이라 높이가 화면 폭에 따라 바뀐다. sticky로 붙는 것들이
     이 값을 알아야 해서 실측해 --header-h로 흘린다 (매직넘버 방지) */
  useLayoutEffect(() => {
    const el = box.current;
    if (!el) return undefined;
    const apply = () =>
      document.documentElement.style.setProperty('--header-h', `${el.offsetHeight}px`);
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  /* AuthContext는 UI를 몰라야 해서 여기서 실패 피드백을 준다.
     안 잡으면 네트워크 오류 때 로그아웃이 조용히 실패하고 사용자는
     로그인 칩이 그대로 떠 있는 이유를 알 방법이 없다 */
  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (e) {
      /* 뭉뚱그린 문구만 띄웠더니 배포 사이트에서만 실패할 때 이유를 알 수 없었다 */
      toast.error(e?.message || '로그아웃에 실패했어요. 다시 시도해 주세요.');
    }
  };

  return (
    <header className="header" ref={box}>
      <div className="header-top">
        <Link to="/" className="logo">
          <FaDice className="dice-icon" />
          <span className="logo-text">롤랜챔</span>
          <span className="logo-tag">LRC</span>
        </Link>

        {configured && !loading && (
          <div className="header-auth">
            {user ? (
              <UserMenu user={user} isAdmin={me?.role === 'admin'} onSignOut={handleSignOut} />
            ) : (
              <button className="login-btn" onClick={() => setShowAuth(true)}>
                로그인
              </button>
            )}
          </div>
        )}
      </div>

      {/* 도구가 늘어나면 이 줄만 길어진다. 넘치면 가로로 스크롤된다 */}
      <nav className="header-nav">
        {/* 홈과 같은 분류·같은 순서로 묶는다. 섞여 있으면 어디가 어딘지 모른다 */}
        <div className="nav-menu">
          {TOOL_SECTIONS.map((section, i) => (
            <React.Fragment key={section.key}>
              {i > 0 && <span className="nav-divider" aria-hidden="true" />}
              <span className="nav-group-label">{section.label}</span>
              {section.tools.map((t) => (
                <NavLink
                  key={t.to}
                  to={t.to}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  title={t.name}
                  aria-label={t.name}
                >
                  <span className="nav-icon">{t.icon}</span>
                  <span className="nav-label">{t.name}</span>
                </NavLink>
              ))}
            </React.Fragment>
          ))}
        </div>
      </nav>

      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </header>
  );
};

export default Header;
